import module from 'viaticos/module.js'

export const schema = {
  responsableId: 'number',
  posicion: 'number',
  requerido: 'boolean',
  requeridoValidar: 'boolean',
  nominas: 'boolean',
  finanzas: 'boolean',
  usuario_id: 'number',
}

export class ViaticosProyectoResponsableService {
  constructor($http) {
    this.$http = $http
  }

  get(id_proyecto) {
    return this.$http.get('/api/viaticos/proyecto/responsables', {
      params: {
        id_proyecto: id_proyecto,
      },
      schema,
    })
  }

  put(id_proyecto, responsables) {
    return this.$http.put('/api/viaticos/proyecto/responsables', responsables, {
      params: {
        id_proyecto: id_proyecto,
      },
    })
  }
}

module.service('ViaticosProyectoResponsableService', ViaticosProyectoResponsableService)



// WEBPACK FOOTER //
// ./src/viaticos/services/Proyecto/Responsables.js